import { zs } from '../schemas/zod';

/** What an item or a purchase is. Mirrors apps/api …/collections/enums/category.py. */
export const categorySchema = zs.enum([
  'water',
  'food',
  'medication',
  'first_aid',
  'hygiene',
  'energy',
  'light',
  'communication',
  'tools',
  'shelter',
  'clothing',
  'documents',
  'money',
  'other',
]);

export type Category = (typeof categorySchema.options)[number];
